import React from "react";
import car from "../../common/assets/images/surveyBannerCar.png";
import { Select } from "antd";

const Banner = () => {
  return (
    <div className="bg-[url('/src/common/assets/images/surveyBanner.png')]">
      <div className="container flex items-center ">
        <div className="w-[30%] flex flex-col gap-7">
          <Select
            defaultValue="Name of Car"
            className="w-full surveySelectField"
            //   onChange={handleChange}
            options={[
              {
                value: "jack",
                label: "Jack",
              },
            ]}
          />
          <Select
            defaultValue="Year of purchase"
            className="w-full surveySelectField"
            //   onChange={handleChange}
            options={[
              {
                value: "jack",
                label: "Jack",
              },
            ]}
          />
        </div>
        <div className="w-[70%]">
          <img src={car} alt="" />
        </div>
      </div>
    </div>
  );
};

export default Banner;
